import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';
import * as antd from 'antd';
import RecommendListStore from 'stores/RecommendListStore';

class GoodsCollectStore {
    SortField = {
        CURRENT_PRICE: 'currentPrice',
        SOLD_NUM: 'soldNum'
    };
    Order = {
        ASC: 'asc',
        DESC: 'desc'
    };
    list = [];
    pageSize = 1000;
    pageNum = 1;
    order = undefined;
    sortField = undefined;
    recommendListStore = new RecommendListStore();

    constructor() {
        makeAutoObservable(this)
    }

    async fetchRecommendList() {
        try {
            await this.recommendListStore.fetchList();
        } catch (error) {
        }
    }

    async fetchList() {
        try {
            const {pageSize, pageNum, order, sortField} = this;

            const {list} = await Api.goodsCollectList({
                pageSize,
                pageNum,
                order,
                sortField
            });

            this.list = list;
        } catch (error) {
        }
    }

    async doDelete(id) {
        try {
            await Api.cancelCollect({
                collectId: id
            });
            antd.message.success('删除成功!');

            await this.fetchList();
        } catch (error) {
        }
    }
}

const store = new GoodsCollectStore();

export default store;
